import React from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {Trip, useGetTrips} from "../../api";
import {Container, ListItem, ListItemButton, ListItemText, Paper, Typography} from "@mui/material";
import {CreateTripModal} from "./CreateTripModal";
import dayjs from "dayjs";
import {SearchableList} from "../common/SearchableList";

function TripMatches(trip: Trip, search: string) {
    return trip.name.toLowerCase().includes(search)
        || trip.description.toLowerCase().includes(search);
}

export function TripList() {
    const navigate = useNavigate();
    const [trip_list, refresh_trips] = useGetTrips();

    const select_trip = (trip: Trip) => {
        navigate('/trips/' + trip.id);
    }

    function render_trip(trip: Trip, i: number) {
        return <ListItem key={i}
                         onClick={() => select_trip(trip)}>
            <ListItemButton>
                <ListItemText primary={trip.name} secondary={
                    <div>
                        <Typography sx={{display: 'inline'}}
                                    component="span"
                                    variant="body2"
                                    color="text.primary">
                            {dayjs(trip.start_date).format("YYYY / MM / DD")}
                        </Typography>
                        {' '} - { trip.description }
                    </div>}/>
            </ListItemButton>
        </ListItem>
    }

    return <div>
        <Container maxWidth="lg">
            <Paper elevation={3}>
                <Box padding={4}>
                    <Typography variant="h4">Trip List</Typography>
                    <SearchableList list={trip_list || []}
                                    render={render_trip}
                                    element_matches={TripMatches}/>
                </Box>
            </Paper>
        </Container>
        <CreateTripModal on_created_trip={() => refresh_trips()}/>
    </div>
}